module.exports = __webpack_public_path__ + "static/media/usatoday.com_pages_interactives_elections-results-primaries-2016__plot.8c05ce21.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/usatoday.com_pages_interactives_elections-results-primaries-2016__plot.png
// module id = 427
// module chunks = 0